const _ = "_container_1ohir_1", o = "_visible_1ohir_1", r = "_fixed_1ohir_1", i = "_absolute_1ohir_1", t = "_relative_1ohir_1", e = "_sticky_1ohir_1", h = "_block_1ohir_1", a = "_inline_1ohir_1", l = "_flex_1ohir_1", p = "_table_1ohir_1", n = "_grid_1ohir_1", s = "_hidden_1ohir_1", d = "_transform_1ohir_1", x = "_fadeInLeft_1ohir_1", c = "_fadeInRight_1ohir_1", f = "_fadeInUp_1ohir_1", g = "_fadeOutLeft_1ohir_1", b = "_fadeOutRight_1ohir_1", m = "_fadeOutUp_1ohir_1", u = "_shake_1ohir_1", w = "_spin_1ohir_1", y = "_resize_1ohir_1", v = "_truncate_1ohir_1", k = "_border_1ohir_1", I = "_underline_1ohir_1", z = "_outline_1ohir_1", O = "_blur_1ohir_1", j = "_filter_1ohir_1", L = "_transition_1ohir_1", R = "_LoadingIndicator_1ohir_68", U = "_text_1ohir_86", S = "_sm_1ohir_90", q = "_md_1ohir_99", A = "_lg_1ohir_108", B = "_xl_1ohir_117", C = "_loader_1ohir_145", D = "_rotate_1ohir_1", E = "_dash_1ohir_1", F = {
  container: _,
  "pointer-events-none": "_pointer-events-none_1ohir_1",
  visible: o,
  static: "_static_1ohir_1",
  fixed: r,
  absolute: i,
  relative: t,
  sticky: e,
  "!left-auto": "_!left-auto_1ohir_1",
  "!right-0": "_!right-0_1ohir_1",
  "-left-100": "_-left-100_1ohir_1",
  "-right-100": "_-right-100_1ohir_1",
  "-top-100": "_-top-100_1ohir_1",
  "bottom-200": "_bottom-200_1ohir_1",
  "bottom-[2px]": "_bottom-[2px]_1ohir_1",
  "left-0": "_left-0_1ohir_1",
  "right-200": "_right-200_1ohir_1",
  "right-auto": "_right-auto_1ohir_1",
  "top-0": "_top-0_1ohir_1",
  "top-[38px]": "_top-[38px]_1ohir_1",
  "top-[78px]": "_top-[78px]_1ohir_1",
  "!z-[39]": "_!z-[39]_1ohir_1",
  "!z-[51]": "_!z-[51]_1ohir_1",
  "z-10": "_z-10_1ohir_1",
  "z-[1005]": "_z-[1005]_1ohir_1",
  "z-[1006]": "_z-[1006]_1ohir_1",
  "!m-0": "_!m-0_1ohir_1",
  "-mx-200": "_-mx-200_1ohir_1",
  "mx-150": "_mx-150_1ohir_1",
  "my-075": "_my-075_1ohir_1",
  "my-100": "_my-100_1ohir_1",
  "!mb-100": "_!mb-100_1ohir_1",
  "!mt-[30px]": "_!mt-[30px]_1ohir_1",
  "-mb-300": "_-mb-300_1ohir_1",
  "-mb-[1px]": "_-mb-[1px]_1ohir_1",
  "-mt-250": "_-mt-250_1ohir_1",
  "mb-025": "_mb-025_1ohir_1",
  "mb-100": "_mb-100_1ohir_1",
  "mb-150": "_mb-150_1ohir_1",
  "mb-200": "_mb-200_1ohir_1",
  "mb-250": "_mb-250_1ohir_1",
  "me-025": "_me-025_1ohir_1",
  "me-300": "_me-300_1ohir_1",
  "ms-075": "_ms-075_1ohir_1",
  "mt-025": "_mt-025_1ohir_1",
  "mt-100": "_mt-100_1ohir_1",
  "mt-250": "_mt-250_1ohir_1",
  "mt-800": "_mt-800_1ohir_1",
  "mt-[3px]": "_mt-[3px]_1ohir_1",
  block: h,
  "inline-block": "_inline-block_1ohir_1",
  inline: a,
  flex: l,
  table: p,
  "table-row": "_table-row_1ohir_1",
  grid: n,
  "!hidden": "_!hidden_1ohir_1",
  hidden: s,
  "!h-[30px]": "_!h-[30px]_1ohir_1",
  "!h-fit": "_!h-fit_1ohir_1",
  "h-200": "_h-200_1ohir_1",
  "h-250": "_h-250_1ohir_1",
  "h-[1000px]": "_h-[1000px]_1ohir_1",
  "h-[100px]": "_h-[100px]_1ohir_1",
  "h-[200px]": "_h-[200px]_1ohir_1",
  "h-[28px]": "_h-[28px]_1ohir_1",
  "h-[600px]": "_h-[600px]_1ohir_1",
  "h-fit": "_h-fit_1ohir_1",
  "h-full": "_h-full_1ohir_1",
  "max-h-[200px]": "_max-h-[200px]_1ohir_1",
  "max-h-[260px]": "_max-h-[260px]_1ohir_1",
  "max-h-[400px]": "_max-h-[400px]_1ohir_1",
  "!min-h-500": "_!min-h-500_1ohir_1",
  "!min-h-600": "_!min-h-600_1ohir_1",
  "!min-h-[60px]": "_!min-h-[60px]_1ohir_1",
  "min-h-500": "_min-h-500_1ohir_1",
  "min-h-[56px]": "_min-h-[56px]_1ohir_1",
  "!w-300": "_!w-300_1ohir_1",
  "!w-[88px]": "_!w-[88px]_1ohir_1",
  "!w-full": "_!w-full_1ohir_1",
  "w-075": "_w-075_1ohir_1",
  "w-1/2": "_w-1/2_1ohir_1",
  "w-200": "_w-200_1ohir_1",
  "w-[100px]": "_w-[100px]_1ohir_1",
  "w-[220px]": "_w-[220px]_1ohir_1",
  "w-[38px]": "_w-[38px]_1ohir_1",
  "w-[400px]": "_w-[400px]_1ohir_1",
  "w-[500px]": "_w-[500px]_1ohir_1",
  "w-[600px]": "_w-[600px]_1ohir_1",
  "w-[70px]": "_w-[70px]_1ohir_1",
  "w-fit": "_w-fit_1ohir_1",
  "w-full": "_w-full_1ohir_1",
  "min-w-400": "_min-w-400_1ohir_1",
  "min-w-[53px]": "_min-w-[53px]_1ohir_1",
  "max-w-[200px]": "_max-w-[200px]_1ohir_1",
  "max-w-[346px]": "_max-w-[346px]_1ohir_1",
  "max-w-[400px]": "_max-w-[400px]_1ohir_1",
  "max-w-[480px]": "_max-w-[480px]_1ohir_1",
  "max-w-[500px]": "_max-w-[500px]_1ohir_1",
  "max-w-[600px]": "_max-w-[600px]_1ohir_1",
  "max-w-[62px]": "_max-w-[62px]_1ohir_1",
  "max-w-[calc(100%-20px)]": "_max-w-[calc(100%-20px)]_1ohir_1",
  "flex-1": "_flex-1_1ohir_1",
  "flex-shrink-0": "_flex-shrink-0_1ohir_1",
  "flex-grow": "_flex-grow_1ohir_1",
  transform: d,
  "animate-fadeInLeft": "_animate-fadeInLeft_1ohir_1",
  fadeInLeft: x,
  "animate-fadeInRight": "_animate-fadeInRight_1ohir_1",
  fadeInRight: c,
  "animate-fadeInUp": "_animate-fadeInUp_1ohir_1",
  fadeInUp: f,
  "animate-fadeOutLeft": "_animate-fadeOutLeft_1ohir_1",
  fadeOutLeft: g,
  "animate-fadeOutRight": "_animate-fadeOutRight_1ohir_1",
  fadeOutRight: b,
  "animate-fadeOutUp": "_animate-fadeOutUp_1ohir_1",
  fadeOutUp: m,
  "animate-shake": "_animate-shake_1ohir_1",
  shake: u,
  "animate-spin": "_animate-spin_1ohir_1",
  spin: w,
  "!cursor-default": "_!cursor-default_1ohir_1",
  "!cursor-not-allowed": "_!cursor-not-allowed_1ohir_1",
  "cursor-default": "_cursor-default_1ohir_1",
  "cursor-not-allowed": "_cursor-not-allowed_1ohir_1",
  "cursor-pointer": "_cursor-pointer_1ohir_1",
  "!resize": "_!resize_1ohir_1",
  resize: y,
  "grid-flow-row": "_grid-flow-row_1ohir_1",
  "grid-cols-2": "_grid-cols-2_1ohir_1",
  "grid-cols-3": "_grid-cols-3_1ohir_1",
  "grid-cols-4": "_grid-cols-4_1ohir_1",
  "grid-cols-7": "_grid-cols-7_1ohir_1",
  "flex-row": "_flex-row_1ohir_1",
  "flex-row-reverse": "_flex-row-reverse_1ohir_1",
  "flex-col": "_flex-col_1ohir_1",
  "flex-wrap": "_flex-wrap_1ohir_1",
  "flex-nowrap": "_flex-nowrap_1ohir_1",
  "content-center": "_content-center_1ohir_1",
  "items-start": "_items-start_1ohir_1",
  "items-end": "_items-end_1ohir_1",
  "!items-center": "_!items-center_1ohir_1",
  "items-center": "_items-center_1ohir_1",
  "!justify-start": "_!justify-start_1ohir_1",
  "justify-start": "_justify-start_1ohir_1",
  "!justify-end": "_!justify-end_1ohir_1",
  "justify-end": "_justify-end_1ohir_1",
  "!justify-center": "_!justify-center_1ohir_1",
  "justify-center": "_justify-center_1ohir_1",
  "justify-between": "_justify-between_1ohir_1",
  "!gap-0": "_!gap-0_1ohir_1",
  "gap-025": "_gap-025_1ohir_1",
  "gap-050": "_gap-050_1ohir_1",
  "gap-075": "_gap-075_1ohir_1",
  "gap-100": "_gap-100_1ohir_1",
  "gap-125": "_gap-125_1ohir_1",
  "gap-150": "_gap-150_1ohir_1",
  "gap-200": "_gap-200_1ohir_1",
  "gap-250": "_gap-250_1ohir_1",
  "gap-300": "_gap-300_1ohir_1",
  "gap-400": "_gap-400_1ohir_1",
  "gap-500": "_gap-500_1ohir_1",
  "gap-600": "_gap-600_1ohir_1",
  "gap-x-100": "_gap-x-100_1ohir_1",
  "gap-y-050": "_gap-y-050_1ohir_1",
  "gap-y-200": "_gap-y-200_1ohir_1",
  "gap-y-500": "_gap-y-500_1ohir_1",
  "overflow-auto": "_overflow-auto_1ohir_1",
  "overflow-hidden": "_overflow-hidden_1ohir_1",
  "overflow-y-auto": "_overflow-y-auto_1ohir_1",
  "overflow-y-hidden": "_overflow-y-hidden_1ohir_1",
  truncate: v,
  "text-ellipsis": "_text-ellipsis_1ohir_1",
  "whitespace-nowrap": "_whitespace-nowrap_1ohir_1",
  "text-wrap": "_text-wrap_1ohir_1",
  "text-nowrap": "_text-nowrap_1ohir_1",
  "!rounded-x-small": "_!rounded-x-small_1ohir_1",
  "rounded-[100%]": "_rounded-[100%]_1ohir_1",
  "rounded-medium": "_rounded-medium_1ohir_1",
  "rounded-small": "_rounded-small_1ohir_1",
  "rounded-x-small": "_rounded-x-small_1ohir_1",
  "rounded-t-small": "_rounded-t-small_1ohir_1",
  "!border-0": "_!border-0_1ohir_1",
  border: k,
  "border-0": "_border-0_1ohir_1",
  "border-2": "_border-2_1ohir_1",
  "border-[1px]": "_border-[1px]_1ohir_1",
  "border-x-0": "_border-x-0_1ohir_1",
  "border-y-[1px]": "_border-y-[1px]_1ohir_1",
  "border-b-0": "_border-b-0_1ohir_1",
  "border-r": "_border-r_1ohir_1",
  "border-t-[1px]": "_border-t-[1px]_1ohir_1",
  "border-solid": "_border-solid_1ohir_1",
  "!border-color-border-lightest": "_!border-color-border-lightest_1ohir_1",
  "border-color-border-lightest": "_border-color-border-lightest_1ohir_1",
  "border-color-fg-light": "_border-color-fg-light_1ohir_1",
  "!bg-color-bg-brand-lightest-default": "_!bg-color-bg-brand-lightest-default_1ohir_1",
  "!bg-color-bg-neutral-lighter-default": "_!bg-color-bg-neutral-lighter-default_1ohir_1",
  "bg-base-colors-black-100": "_bg-base-colors-black-100_1ohir_1",
  "bg-base-colors-grey-300": "_bg-base-colors-grey-300_1ohir_1",
  "bg-base-colors-grey-700": "_bg-base-colors-grey-700_1ohir_1",
  "bg-base-colors-white-700": "_bg-base-colors-white-700_1ohir_1",
  "bg-color-bg-base-pressed": "_bg-color-bg-base-pressed_1ohir_1",
  "bg-color-bg-neutral-lightest-default": "_bg-color-bg-neutral-lightest-default_1ohir_1",
  "fill-color-bg-base-default": "_fill-color-bg-base-default_1ohir_1",
  "fill-color-bg-neutral-boldest-default": "_fill-color-bg-neutral-boldest-default_1ohir_1",
  "stroke-base-colors-grey-300": "_stroke-base-colors-grey-300_1ohir_1",
  "stroke-base-colors-grey-500": "_stroke-base-colors-grey-500_1ohir_1",
  "!p-0": "_!p-0_1ohir_1",
  "p-025": "_p-025_1ohir_1",
  "p-075": "_p-075_1ohir_1",
  "p-100": "_p-100_1ohir_1",
  "p-150": "_p-150_1ohir_1",
  "p-200": "_p-200_1ohir_1",
  "p-250": "_p-250_1ohir_1",
  "p-300": "_p-300_1ohir_1",
  "p-500": "_p-500_1ohir_1",
  "p-[10px]": "_p-[10px]_1ohir_1",
  "p-[12px]": "_p-[12px]_1ohir_1",
  "!py-0": "_!py-0_1ohir_1",
  "px-050": "_px-050_1ohir_1",
  "px-150": "_px-150_1ohir_1",
  "px-200": "_px-200_1ohir_1",
  "px-300": "_px-300_1ohir_1",
  "px-400": "_px-400_1ohir_1",
  "py-025": "_py-025_1ohir_1",
  "py-050": "_py-050_1ohir_1",
  "py-075": "_py-075_1ohir_1",
  "py-100": "_py-100_1ohir_1",
  "py-125": "_py-125_1ohir_1",
  "py-150": "_py-150_1ohir_1",
  "py-300": "_py-300_1ohir_1",
  "py-[2.5px]": "_py-[2.5px]_1ohir_1",
  "pb-0": "_pb-0_1ohir_1",
  "pb-075": "_pb-075_1ohir_1",
  "pb-100": "_pb-100_1ohir_1",
  "pb-125": "_pb-125_1ohir_1",
  "pb-200": "_pb-200_1ohir_1",
  "pe-150": "_pe-150_1ohir_1",
  "pe-200": "_pe-200_1ohir_1",
  "pe-250": "_pe-250_1ohir_1",
  "pl-200": "_pl-200_1ohir_1",
  "pr-150": "_pr-150_1ohir_1",
  "pt-0": "_pt-0_1ohir_1",
  "pt-025": "_pt-025_1ohir_1",
  "pt-050": "_pt-050_1ohir_1",
  "pt-075": "_pt-075_1ohir_1",
  "pt-100": "_pt-100_1ohir_1",
  "pt-200": "_pt-200_1ohir_1",
  "pt-[22px]": "_pt-[22px]_1ohir_1",
  "align-middle": "_align-middle_1ohir_1",
  "text-xl": "_text-xl_1ohir_1",
  "text-color-fg-bold": "_text-color-fg-bold_1ohir_1",
  "text-color-fg-brand-default": "_text-color-fg-brand-default_1ohir_1",
  "text-color-fg-danger-default": "_text-color-fg-danger-default_1ohir_1",
  "text-color-fg-inverse": "_text-color-fg-inverse_1ohir_1",
  "text-color-fg-light": "_text-color-fg-light_1ohir_1",
  "text-color-fg-lighter": "_text-color-fg-lighter_1ohir_1",
  "text-color-fg-lightest": "_text-color-fg-lightest_1ohir_1",
  "text-color-fg-success-default": "_text-color-fg-success-default_1ohir_1",
  "text-color-fg-warning-default": "_text-color-fg-warning-default_1ohir_1",
  underline: I,
  "line-through": "_line-through_1ohir_1",
  "!opacity-0": "_!opacity-0_1ohir_1",
  "!opacity-100": "_!opacity-100_1ohir_1",
  "opacity-40": "_opacity-40_1ohir_1",
  "opacity-disabled": "_opacity-disabled_1ohir_1",
  "shadow-ambient": "_shadow-ambient_1ohir_1",
  "shadow-m-mixed": "_shadow-m-mixed_1ohir_1",
  outline: z,
  blur: O,
  filter: j,
  transition: L,
  "!duration-300": "_!duration-300_1ohir_1",
  "duration-[200ms]": "_duration-[200ms]_1ohir_1",
  "!ease-out": "_!ease-out_1ohir_1",
  "ease-in-out": "_ease-in-out_1ohir_1",
  "ease-out": "_ease-out_1ohir_1",
  "ds-maken-theme": "_ds-maken-theme_1ohir_26",
  LoadingIndicator: R,
  text: U,
  sm: S,
  md: q,
  lg: A,
  xl: B,
  loader: C,
  rotate: D,
  dash: E,
  "first:mt-0": "_first:mt-0_1ohir_1",
  "last:mb-0": "_last:mb-0_1ohir_1",
  "hover:text-color-fg-bold": "_hover:text-color-fg-bold_1ohir_1",
  "active:text-color-fg-bold": "_active:text-color-fg-bold_1ohir_1"
};
export {
  R as LoadingIndicator,
  i as absolute,
  h as block,
  O as blur,
  k as border,
  _ as container,
  E as dash,
  F as default,
  x as fadeInLeft,
  c as fadeInRight,
  f as fadeInUp,
  g as fadeOutLeft,
  b as fadeOutRight,
  m as fadeOutUp,
  j as filter,
  r as fixed,
  l as flex,
  n as grid,
  s as hidden,
  a as inline,
  A as lg,
  C as loader,
  q as md,
  z as outline,
  t as relative,
  y as resize,
  D as rotate,
  u as shake,
  S as sm,
  w as spin,
  e as sticky,
  p as table,
  U as text,
  d as transform,
  L as transition,
  v as truncate,
  I as underline,
  o as visible,
  B as xl
};
//# sourceMappingURL=LoadingIndicator.module.scss.js.map
